export const environmentKeys = {
  dev: {
    devtools: true,
    reportingServiceUrl: "https://prolifecv-dev.api.tatamotors",
  },
  production: {
    devtools: false,
    reportingServiceUrl: "https://prolifecv.api.tatamotors",
  },
};
 
